import { mutatorAction, mutator } from 'satcheljs';
import getListViewState from '../selectors/getListViewState';
import { onModuleClick } from 'owa-workloads';
import { Module } from 'owa-workloads-module';

export const updateStartAndEndIndicesInVLVMutator: (start: number, end: number) => void =
    mutatorAction('updateStartAndEndIndicesInVLVMutator', (start: number, end: number): void => {
        const listViewState = getListViewState();
        listViewState.startIndexVLV = start;
        listViewState.endIndexVLV = end;
    });

// When the selected module changes away from Mail (and the component unmounts), reset the start
// and end indices in the listViewState as nothing is visible. This ensures that when we remount
// the component, we don't have stale // indices in the listViewState and can properly determine
// whether to scroll to the focused row.
mutator(onModuleClick, actionMessage => {
    if (actionMessage.module !== Module.Mail) {
        const listViewState = getListViewState();
        listViewState.startIndexVLV = -1;
        listViewState.endIndexVLV = -1;
    }
});
